var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Single extends Component {
    constructor() {
        super('Single', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.link-scroll-to').on('click', (event, link) => {
                event.preventDefault();
                const headerHeight = $('header').height() + 25;
                if ($('body').hasClass('single-material')) {
                    $.scrollTo($(link.attr('href')).position().y - headerHeight, 500);
                }
                else {
                    const scrollTop = $(window).width() < 992 ? 0 : $('.double-scroll').get(0).scrollTop;
                    const container = $(window).width() < 992 ? $('body') : $('.double-scroll');
                    const imageY = $(link.attr('href')).position(container).y;
                    const top = scrollTop + imageY - headerHeight;
                    if ($(window).width() < 992) {
                        $.scrollTo(top, 500);
                    }
                    else {
                        $('.double-scroll').get(0).scrollTo({
                            top: top,
                            behavior: 'smooth'
                        });
                    }
                }
            });
            this.success();
        });
    }
}
